/* GlamourGallery — mobile cart drawer inline voucher (scratch card)
 * Sentinel: gg-mobile-voucher-v2
 *
 * Mobile-only (≤640px). The user scratches the foil overlay to
 * reveal the discount code. Tapping the revealed code copies it
 * to the clipboard. No auto-apply — the customer pastes it into
 * the discount field themselves.
 *
 * Tablet keeps the floating gift-tag pendant, desktop is unaffected.
 */
(function () {
  'use strict';

  var CODE      = 'WELCOME10';
  var DISCOUNT  = '10%';
  var THRESHOLD = '£50';
  var MQ_MOBILE = '(max-width: 640px)';
  var INJECT_ID = 'gg-mobile-voucher';

  function isMobile() {
    return !!(window.matchMedia && window.matchMedia(MQ_MOBILE).matches);
  }

  function buildHTML() {
    return (
      '<aside id="' + INJECT_ID + '" class="gg-mobile-voucher" data-revealed="false" role="region" aria-label="Discount offer — scratch to reveal">' +
        '<div class="gg-mobile-voucher__head">' +
          '<span class="gg-mobile-voucher__eyebrow">A small thank you</span>' +
          '<p class="gg-mobile-voucher__line">' +
            '<span class="gg-mobile-voucher__pct">' + DISCOUNT + '</span> off your first basket' +
          '</p>' +
          '<p class="gg-mobile-voucher__sub">For first baskets over ' + THRESHOLD + '. One per customer.</p>' +
        '</div>' +
        '<div class="gg-mobile-voucher__scratch" data-gg-scratch>' +
          '<button type="button" class="gg-mobile-voucher__code" data-gg-code aria-label="Copy code">' +
            '<span class="gg-mobile-voucher__code-label">' + CODE + '</span>' +
            '<span class="gg-mobile-voucher__copy-hint" aria-hidden="true">Tap to copy</span>' +
          '</button>' +
          '<canvas class="gg-mobile-voucher__foil" aria-hidden="true"></canvas>' +
          '<span class="gg-mobile-voucher__foil-hint" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M3 12 Q9 4 15 12 T 21 14"/>' +
              '<path d="M14 4 7 11"/>' +
            '</svg>' +
            'Scratch to reveal' +
          '</span>' +
        '</div>' +
      '</aside>'
    );
  }

  /* Paint the foil layer over the canvas. Returns the canvas
   * 2d context for later scratching. */
  function paintFoil(canvas) {
    var rect = canvas.getBoundingClientRect();
    var dpr = window.devicePixelRatio || 1;
    canvas.width  = Math.max(1, Math.floor(rect.width  * dpr));
    canvas.height = Math.max(1, Math.floor(rect.height * dpr));
    var ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    // Brass foil gradient
    var g = ctx.createLinearGradient(0, 0, rect.width, rect.height);
    g.addColorStop(0,    '#E5D4B5');
    g.addColorStop(0.45, '#C9A87C');
    g.addColorStop(0.7,  '#B0905F');
    g.addColorStop(1,    '#8a6b40');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, rect.width, rect.height);

    // Foil specks
    ctx.fillStyle = 'rgba(255, 253, 247, 0.18)';
    for (var i = 0; i < 90; i++) {
      var x = Math.random() * rect.width;
      var y = Math.random() * rect.height;
      var s = Math.random() * 1.5 + 0.3;
      ctx.fillRect(x, y, s, s);
    }

    ctx.globalCompositeOperation = 'destination-out';
    return ctx;
  }

  function attachScratch(voucher) {
    var canvas = voucher.querySelector('canvas.gg-mobile-voucher__foil');
    if (!canvas) return;

    // Pre-paint the foil immediately so the canvas pixels exist whether
    // or not the user interacts. Without this, the visible "foil" is the
    // CSS gradient fallback and scratching has nothing to erase.
    var ctx = paintFoil(canvas);

    function scratchAt(clientX, clientY, radius) {
      var rect = canvas.getBoundingClientRect();
      if (rect.width === 0) return;
      var x = clientX - rect.left;
      var y = clientY - rect.top;
      ctx.beginPath();
      ctx.arc(x, y, radius || 22, 0, Math.PI * 2);
      ctx.fill();
    }

    function clearedPercent() {
      var rect = canvas.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) return 0;
      try {
        var sample = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var d = sample.data;
        var clear = 0;
        var step = 40;
        for (var i = 3; i < d.length; i += 4 * step) {
          if (d[i] < 12) clear++;
        }
        var total = d.length / (4 * step);
        return clear / total;
      } catch (_) {
        return 0;   // tainted canvas — fall back to tap counter
      }
    }

    var dragging = false;
    var scratchCount = 0;
    var revealed = false;

    function start(ev) {
      dragging = true;
      scratchCount++;
      var p = ev.touches ? ev.touches[0] : ev;
      scratchAt(p.clientX, p.clientY, 26);
      if (ev.cancelable) ev.preventDefault();
      checkReveal();
    }
    function move(ev) {
      if (!dragging) return;
      var p = ev.touches ? ev.touches[0] : ev;
      scratchAt(p.clientX, p.clientY, 22);
      if (ev.cancelable) ev.preventDefault();
      // Don't check every move — too expensive. Sample every 4th move.
      if (Math.random() < 0.25) checkReveal();
    }
    function end() {
      dragging = false;
      checkReveal();
    }
    function checkReveal() {
      if (revealed) return;
      // Reveal if either:
      //   - getImageData says >25% cleared
      //   - user has scratched at least 4 separate strokes (works even if
      //     getImageData is tainted, e.g. in headless test environments)
      if (clearedPercent() > 0.25 || scratchCount >= 4) reveal();
    }
    canvas.addEventListener('mousedown', start);
    canvas.addEventListener('mousemove', move);
    canvas.addEventListener('mouseup', end);
    canvas.addEventListener('mouseleave', end);
    canvas.addEventListener('touchstart', start, { passive: false });
    canvas.addEventListener('touchmove',  move,  { passive: false });
    canvas.addEventListener('touchend',   end);

    function reveal() {
      if (revealed) return;
      revealed = true;
      voucher.setAttribute('data-revealed', 'true');
      canvas.style.opacity = '0';
      setTimeout(function () { try { canvas.remove(); } catch (_) {} }, 280);
    }

    // Re-paint on resize so the foil layer matches the box
    window.addEventListener('resize', function () {
      if (revealed) return;
      ctx = paintFoil(canvas);
    });
  }

  function attachCopy(voucher) {
    var btn = voucher.querySelector('[data-gg-code]');
    if (!btn) return;
    btn.addEventListener('click', async function (ev) {
      if (voucher.getAttribute('data-revealed') !== 'true') return;  // ignore taps until revealed
      ev.preventDefault();
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(CODE);
        } else {
          var ta = document.createElement('textarea');
          ta.value = CODE; document.body.appendChild(ta);
          ta.select(); document.execCommand('copy'); document.body.removeChild(ta);
        }
        var hint = btn.querySelector('.gg-mobile-voucher__copy-hint');
        var orig = hint ? hint.textContent : '';
        if (hint) hint.textContent = 'Copied — paste at discount';
        btn.classList.add('is-copied');
        setTimeout(function () {
          if (hint) hint.textContent = orig || 'Tap to copy';
          btn.classList.remove('is-copied');
        }, 2400);
      } catch (_) {}
    });
  }

  function inject(dialog) {
    if (!dialog) return;
    if (dialog.querySelector('#' + INJECT_ID)) return;
    if (!isMobile()) return;

    var inner = dialog.querySelector('.cart-drawer__inner');
    if (!inner) return;
    var header = inner.querySelector('.cart-drawer__header, .gg-cart-populated-header');

    var temp = document.createElement('div');
    temp.innerHTML = buildHTML();
    var node = temp.firstElementChild;

    if (header && header.parentNode) {
      header.parentNode.insertBefore(node, header.nextSibling);
    } else {
      inner.insertBefore(node, inner.firstChild);
    }

    // Defer one frame so the canvas has measurable layout
    requestAnimationFrame(function () {
      attachScratch(node);
      attachCopy(node);
    });
  }

  function init() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    var dialog = drawer.querySelector('dialog');
    if (!dialog) return;

    if (dialog.hasAttribute('open') && isMobile()) inject(dialog);

    var attrObs = new MutationObserver(function () {
      if (dialog.hasAttribute('open') && isMobile()) {
        requestAnimationFrame(function () { inject(dialog); });
      }
    });
    attrObs.observe(dialog, { attributes: true, attributeFilter: ['open'] });

    var innerObs = new MutationObserver(function () {
      if (dialog.hasAttribute('open') && isMobile() && !dialog.querySelector('#' + INJECT_ID)) {
        inject(dialog);
      }
    });
    innerObs.observe(dialog, { childList: true, subtree: true });

    if (window.matchMedia) {
      var mq = window.matchMedia(MQ_MOBILE);
      var onMQ = function () {
        var existing = dialog.querySelector('#' + INJECT_ID);
        if (mq.matches && dialog.hasAttribute('open')) {
          if (!existing) inject(dialog);
        } else if (!mq.matches && existing) {
          existing.remove();
        }
      };
      if (mq.addEventListener) mq.addEventListener('change', onMQ);
      else if (mq.addListener) mq.addListener(onMQ);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
